export default {
    'NODE_ENV': process.env.NODE_ENV || 'production',
    'API_URL': process.env.API_URL || 'https://lmbk-api.herokuapp.com',
    'WS_URL':process.env.WS_URL || 'wss://lmbk-api.herokuapp.com',
    'APP_URL': process.env.APP_URL || 'https://app.lmbk.io',
}
